// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M10.5 1.5H14.5V5.5M14.5 1.5L10 6M5.5 14.5H1.5V10.5M1.5 14.5L6 10',
];
